import React, { useEffect, useState } from 'react';
import {
  Box, Typography, CircularProgress, Tab, Tabs,
  Stack, TextField, Paper
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import SwipeableViews from 'react-swipeable-views';
import moment from 'moment';
import { useGetDailySessionsQuery, useGetRoutineByIdQuery } from 'redux/reducers/user/dashboard';
import Feedback from '../Feedback';
import DailySession from './DailySessioon';

interface TabPanelProps {
  value: number;
  routineId: number;
}

const TabPanel = ({ routineId }: TabPanelProps) => {
  const [dateValue, setDateValue] = useState<string>(moment().format('YYYY-MM-DD'));
  const [tabValue, setTabValue] = useState(0);
  const theme = useTheme();

  const { data: customData, isFetching } = useGetRoutineByIdQuery(routineId);

  const { refetch: refetchDailySession } = useGetDailySessionsQuery(
    {
      date: dateValue,
      routine_id: routineId
    },
    {
      skip: !routineId,
      refetchOnMountOrArgChange: true
    }
  );

  useEffect(() => {
    if (dateValue) refetchDailySession();
  }, [dateValue, routineId, refetchDailySession]);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => setTabValue(newValue);

  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      {isFetching ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}>
          <CircularProgress size={40} thickness={4} />
        </Box>
      ) : (
        <>
          {/* <Stack 
            direction={{ xs: 'column', sm: 'row' }} 
            justifyContent="space-between" 
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            spacing={2}
            sx={{ mb: 4 }}
          >
            <Box>
              <Typography variant="h5" sx={{ fontWeight: 700, color: 'text.primary' }}>
                {customData?.hall_details?.hall_name || 'Hall Details'}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Manage sessions and view feedback
              </Typography>
            </Box>

            <TextField
              type="date"
              label="Select Date"
              value={dateValue}
              onChange={(e) => setDateValue(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{ 
                width: { xs: '100%', sm: 250 },
                bgcolor: 'white',
                '& .MuiOutlinedInput-root': { borderRadius: 2 }
              }}
            />
          </Stack> */}

          <Paper elevation={0} sx={{ borderRadius: 3, border: '1px solid', borderColor: 'divider', overflow: 'hidden' }}>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                bgcolor: 'white',
                borderBottom: '1px solid',
                borderColor: 'divider',
                '& .MuiTab-root': { py: 2, fontWeight: 600 }
              }}
            >
              {/* <Tab label="Daily Sessions" /> */}
              <Tab label="Feedbacks" />
            </Tabs>

            <SwipeableViews
              axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
              index={tabValue}
              onChangeIndex={(index) => setTabValue(index)}
            >
              {/* <Box sx={{ p: { xs: 1, sm: 3 } }}>
                <DailySession routineId={routineId} dateValue={dateValue} />
              </Box> */}
              <Box sx={{ p: { xs: 1, sm: 3 } }}>
                <Feedback />
              </Box>
            </SwipeableViews>
          </Paper>
        </>
      )}
    </Box>
  );
};

export default TabPanel;